import { dynamicApi, getShopifyUserId, companyUUID } from '@/service/api';
import { LogJsError } from '@/service/monitor';

// 使用示例
// loadScript({
//   url: 'path/to/your/script.js',
//   async: true, // 设置为true以异步加载脚本
//   defer: false // 设置为false以立即执行脚本（不考虑async），或等待文档解析完成（如果async也为true）
// })
//   .then(() => {
//     console.log('Script loaded successfully!');
//   })
//   .catch((error) => {
//     console.error('Script loading failed:', error.message);
//   });
export function loadScript(config) {
  return new Promise((resolve, reject) => {
    const {
      url, // script的URL，必传参数
      async = false, // 是否异步加载script，默认false
      defer = false // 是否延迟执行script，默认false
    } = config;

    if (!url) {
      return reject(new Error('url is required for loading a script.'));
    }

    // 创建script元素
    const script = document.createElement('script');
    script.src = url;
    script.async = async;
    script.defer = defer;

    // 加载成功时解析Promise
    script.onload = () => resolve(script);
    // 加载失败时拒绝Promise
    script.onerror = () => {
      return reject(new Error(`script load failed for url: ${url}`));
    };

    // 将script元素添加到文档中
    document.head.appendChild(script);
  });
}

export function addDynamicJS(path = 'form/stlye') {
  dynamicApi(
    {
      uid: getShopifyUserId(),
      companyUid: companyUUID,
      // 可通过query加参 eXtc=UZiVPQ 控制走不同JS
      pathName: window.location.href
    },
    path
  )
    .then((response) => {
      if (response?.data?.code === 0) {
        let url = response?.data?.data;
        if (!url.includes('.js')) {
          throw new Error('dynamic url is wrong');
        }
        // 预期JS脚本逻辑独立，加载完立即执行
        // 不阻塞html渲染
        loadScript({
          url,
          async: true,
          defer: false
        })
          .then(() => {
            console.log(url + ' loaded successfully!');
          })
          .catch((error) => {
            throw error;
          });
      }
    })
    .catch((error) => {
      LogJsError({
        em: error.message,
        es: error.stack
      });
    });
}
